import { render, staticRenderFns } from "./DashboardAcademicsHub.vue?vue&type=template&id=4528795d&scoped=true&"
import script from "./DashboardAcademicsHub.vue?vue&type=script&lang=js&"
export * from "./DashboardAcademicsHub.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAcademicsHub.vue?vue&type=style&index=0&id=4528795d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528795d",
  null
  
)

export default component.exports